import { render } from "./GuestIdentityUpload.vue?vue&type=template&id=7ad5b606"
import script from "./GuestIdentityUpload.vue?vue&type=script&lang=js"
export * from "./GuestIdentityUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__